import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const AutoMicrophone = ({
  caller_avatar,
  scrollRef,
  setTransitionText,
  oldTransitionText,
}) => {
  const [transcript, setTranscript] = useState("");
  const [isBrowserSupported, setIsBrowserSupported] = useState(true);
  const recognitionRef = useRef(null);
  const finalTranscriptRef = useRef("");
  const themeMode = useSelector((state) => state.themeMode);

  useEffect(() => {
    // Check browser support
    if (
      !("webkitSpeechRecognition" in window) &&
      !("SpeechRecognition" in window)
    ) {
      setIsBrowserSupported(false);
      return;
    }

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    recognitionRef.current = new SpeechRecognition();
    recognitionRef.current.continuous = true;
    recognitionRef.current.interimResults = true;
    recognitionRef.current.lang = "en-US";

    recognitionRef.current.onresult = (event) => {
      handleEventThing(event);
    };

    recognitionRef.current.onstart = () => {
      console.log("listening");
    };

    recognitionRef.current.onerror = (event) => {
      setTimeout(() => {
        startRecognition();
      }, 1000);
    };

    recognitionRef.current.onend = () => {
      setTimeout(() => {
        startRecognition();
      }, 500);
    };

    const startRecognition = () => {
      try {
        recognitionRef.current.start();
      } catch (error) {
        setTimeout(() => {
          startRecognition();
        }, 1000);
      }
    };

    // Start listening immediately
    startRecognition();

    return () => {
      recognitionRef.current?.stop();
    };
  }, [setTransitionText]);

  const handleEventThing = (event) => {
    let interimTranscript = "";
    let newFinalTranscript = "";

    for (let i = event.resultIndex; i < event.results.length; i++) {
      const result = event.results[i];
      const text = result[0].transcript;

      if (result.isFinal) {
        // eslint-disable-next-line
        newFinalTranscript += text + " ";
        finalTranscriptRef.current += text + " ";
      } else {
        interimTranscript += text;
      }
    }

    setTranscript(finalTranscriptRef.current + interimTranscript);
    setTransitionText(finalTranscriptRef.current + interimTranscript);
  };

  if (!isBrowserSupported) {
    return (
      <div className="app">
        <h1>Voice to Text</h1>
        <p className="error">
          Your browser doesn't support speech recognition. Try Chrome or Edge.
        </p>
      </div>
    );
  }

  const getDifference = () => {
    const str1 = oldTransitionText;
    const str2 = transcript;

    if (str2.startsWith(str1)) {
      const difference = str2.slice(str1.length);
      return difference;
    } else {
      return str2;
    }
  };

  return (
    <>
      {getDifference().length === 0 ? (
        <></>
      ) : (
        <div className="private-chat-main-section" ref={scrollRef}>
          <div className="chat-avatar">
            <img
              alt="avatar"
              className="interviewer-avatar"
              src={caller_avatar}
            />
          </div>
          <div className="chat-content-section">
            <div
              className={`chat-content-title ${
                themeMode.themeMode
                  ? "chat-content-title-dark"
                  : "chat-content-title-light"
              }`}
            >
              You
            </div>
            <div className="chat-content-desc">{getDifference()}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default AutoMicrophone;
